import React from "react";

const DefaultBoxPreview = () => {
  return (
    <div className="box_preview">
      <strong className="screen_out">미리보기 목록</strong>
      <ul className="list_box_preview list_box_preview_type1">
        <li>
          <div className="box_pos pos_top">
            <span className="txt_g">목록 상단</span>
          </div>
        </li>
        <li>
          <div className="box_pos pos_bot">
            <span className="txt_g">목록 하단</span>
          </div>
        </li>
        <li>
          <div className="box_pos pos_sidebar">
            <span className="txt_g">사이드바</span>
          </div>
        </li>
        <li>
          <div className="box_pos pos_cont_top">
            <span className="txt_g">본문 상단</span>
          </div>
        </li>
        <li>
          <div className="box_pos pos_cont_bot">
            <span className="txt_g">본문 하단</span>
          </div>
        </li>
      </ul>
    </div>
  )
};
export default DefaultBoxPreview;